import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const getTypeInterviewLabel = (type, t) => {
  switch (type) {
    case 'type_interview_clients':
      return t('Clienti');
    case 'type_interview_company':
      return t('INSEGNE');
    default:
      return display(type);
  }
};

const getQuestionFields = (questions, t) => {
  if (!questions?.length) {
    return [{ text: t('Domande'), value: '—' }];
  }

  return questions.flatMap((question, index) => {
    const answers = [1, 2, 3, 4, 5]
      .map((n) => question[`question${n}`])
      .filter(Boolean);

    const fields = [
      {
        text: `${t('Domanda n.')} ${index + 1}`,
        value: display(question.title),
      },
      {
        text: t('Tipo'),
        value: question.is_input_text
          ? t('Domanda aperta')
          : t('Risposta chiusa'),
      },
    ];

    if (!question.is_input_text && answers.length > 0) {
      answers.forEach((answer, answerIndex) => {
        fields.push({
          text: `${t('Risposta')} ${answerIndex + 1}`,
          value: answer,
        });
      });
    }

    return fields;
  });
};

export const getInterviewViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const categoryTitles =
    item.company_categories?.map((category) => category.title).join(', ') ||
    '';

  const sections = [
    {
      title: t('Informazioni Generali'),
      fields: [
        { text: t('Titolo'), value: display(item.title) },
        {
          text: t('Outlet Village'),
          value: display(
            item['shopping_centers.title'] || item.shopping_center?.title,
          ),
        },
        {
          text: t('DATA INIZIO SONDAGGIO'),
          value: displayDate(item.date_from),
        },
        {
          text: t('DATA FINE SONDAGGIO'),
          value: displayDate(item.date_to),
        },
        {
          text: t('DESTINATARI'),
          value: getTypeInterviewLabel(item.type_interview, t),
        },
        {
          text: t('Insegne/clienti che hanno risposto'),
          value: display(item.count_answers),
        },
      ],
    },
  ];

  if (item.type_interview === 'type_interview_company') {
    sections[0].fields.push(
      {
        text: t('Selezione categorie stores su cui effettuare il sondaggio'),
        value: display(categoryTitles),
      },
      {
        text: t('Pubblicazione su Telegram'),
        value: displayBool(item.in_telegram, t),
      },
    );
  }

  sections.push({
    title: t('Domande'),
    fields: getQuestionFields(item.interview_questions, t),
  });

  return sections;
};
